/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.thresholds = skyward.thresholds || {};

        var init = function (selector)
        {
            // Initialize Rule Type Combobox
            if ($(selector).find(".ruleTypeSelector").length > 0)
            {
                var element = $(selector).find(".ruleTypeSelector");
                element.each(handleRuleTypeChange.bind(element, selector));
                element.change(handleRuleTypeChange.bind(element, selector));
            }
            // Initialize Test Version Field Selector
            if ($(selector).find('[id*="AssessmentTestVersionFieldID-add"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="AssessmentTestVersionFieldID-add"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
                element.trigger("change")
            }

            if ($(selector).find('[id*="editThresholdRuleGroup_AssessmentTestVersionFieldID"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="editThresholdRuleGroup_AssessmentTestVersionFieldID"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
            }

            if ($(selector).find('[id*="TempThresholdRuleGroup-"][id*="AssessmentTestVersionFieldID-"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="TempThresholdRuleGroup-"][id*="AssessmentTestVersionFieldID-"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
            }

            if ($(selector).find('.js-ThresholdTestVersionID').length > 0)
            {
                var element = $(selector).find('.js-ThresholdTestVersionID');
                element.change(clearAssessmentCRQE);
            }

            if ($(selector).find('.js-updateConditionValueOnOperationChange').length > 0)
            {
                var element = $(selector).find('.js-updateConditionValueOnOperationChange');
                element.change(handleConditionChange);
            }

            if ($(selector).find('.js-useForMTSSCheckbox').length > 0)
            {
                var element = $(selector).find(".js-useForMTSSCheckbox");
                element.each(handleUseForMTSSChange);
                element.change(handleUseForMTSSChange);
            }

            if ($(selector).find('.js-tempThresholdName').length > 0)
            {
                var element = $(selector).find(".js-tempThresholdName");
                element.change(handleTempThresholdRuleGroupNameChange);
            }

            if ($(selector).find('.js-skipEntityYearConditionCheckbox').length > 0)
            {
                var element = $(selector).find(".js-skipEntityYearConditionCheckbox");
                var ruleTypeElement = $(selector).find(".ruleTypeSelector");
                // handleRuleTypeChange assumes "this" is the ruleTypeSelector
                element.each(handleRuleTypeChange.bind(ruleTypeElement, selector));
                processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue(ruleTypeElement), true);
                element.change(function ()
                {
                    handleRuleTypeChange.call(ruleTypeElement, selector);
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue($(this)), skyward.controls.getValue(ruleTypeElement));
                });
                // also set up another change event on RuleType so that control visibility always stays up-to-date
                ruleTypeElement.change(function ()
                {
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue($(this)));
                });
            }

            if ($(selector).find(".js-otherEntityIDs").length > 0)
            {
                $(selector).find(".js-otherEntityIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnEntityChange", selector));
                });
            }

            if ($(selector).find(".js-otherSchoolYearIDs").length > 0)
            {
                $(selector).find(".js-otherSchoolYearIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnSchoolYearChange", selector));
                });
            }

            var useForCheckboxGroup = $(selector).find(".js-thresholdGroupUseFor");
            if (useForCheckboxGroup.length > 0)
            {
                useForCheckboxGroup.debounce("change", function ()
                {
                    processUseForDependents(selector, $(this));
                }, 10);
                processUseForDependents(selector, useForCheckboxGroup, true);
            }

            if ($(selector).find(".js-tempThresholdRuleGroupID").length > 0)
            {
                $(selector).find(".js-tempThresholdRuleGroupID").on("eelComplete", ".codeEEL", handleTempThresholdRuleGroupChange);
                $(selector).find(".js-tempThresholdRuleGroupID .codeEEL").each(handleTempThresholdRuleGroupChange);
            }

            if (!$(".js-ThresholdGroupSkywardID").val())
            {
                // RuleTypes that require "Number of Occurrences = 1" helper
                $(selector).find(".js-thresholdRuleGroupID").on("eelComplete", ".codeEEL", handleReadonlyRuleTypes);
                // This ensures any of the readonly rules are made readonly and "Number of Occurences = 1" at page load
                // At page load, the .codeEELCode textbox has data-additional-fields, not the .codeEEL container
                $(selector).find(".js-thresholdRuleGroupID .codeEELCode").each(handleReadonlyRuleTypes);
            }
        };

        var clearAssessmentCRQE = function () {
            var viewer = $(this).parents('[id*="RuleConditionsDiv"]');
            var ruleConditionQuickEntryfs = viewer.find('[id*="TestVersionFieldCRQE"].childrecordquickentry');
            ruleConditionQuickEntryfs.find(".childrecordquickentryclearbuttoncell, .childrecordquickentryremovebuttoncell").each(function () { $(this).find('.button').click(); });
        }

        var handleConditionChange = function (selector)
        {
            var operationTypeInput = $(this);
            var prefix = operationTypeInput.attr('id').substring(0, operationTypeInput.attr('id').lastIndexOf("-"));
            var ruleConditionsSelector = '#' + prefix + '-Value';
            var ruleConditionValue = null;
            var skywardID = null;
            var thresholdConditionID = null;

            if ($(ruleConditionsSelector)[0])
            {
                var backingDataInput = $(ruleConditionsSelector + 'Input');
                var newOperationType = operationTypeInput.val();
                if (backingDataInput.length > 0)
                {
                    // The MultipleSelectBox wrapper has no value of its own; its selections live on the backing data.
                    // Only carry them over when the new operation type (List/Not List) also renders a MultipleSelectBox.
                    if (newOperationType === 'L' || newOperationType === 'NL')
                    {
                        ruleConditionValue = JSON.stringify(skyward.controls.getValue(backingDataInput));
                    }
                }
                else
                {
                    ruleConditionValue = $(ruleConditionsSelector).val();
                }

                skywardID = $(ruleConditionsSelector).data('skywardid');
                thresholdConditionID = $(ruleConditionsSelector).data('thresholdconditionid');
            }

            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/UpdateRuleOnUpdateOperationType",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    operationTypeInput: operationTypeInput.val(),
                    prefix: prefix,
                    conditionValue: ruleConditionValue,
                    conditionSkywardID: skywardID,
                    conditionThresholdConditionID: thresholdConditionID
                },
                success: function (data)
                {
                    if ($(ruleConditionsSelector)[0])
                    {
                        // List/Not List render a MultipleSelectBox whose backing data (id ending in "Input") holds a JSON array;
                        // the other operation types render a single-value control. Only carry the original value over when the
                        // old and new controls store their values the same way, otherwise change tracking breaks on the mismatch.
                        var hadBackingDataInput = $(ruleConditionsSelector + 'Input').length > 0;
                        var originalValueAttr = $(ruleConditionsSelector).attr('data-original-value') ?? $(ruleConditionsSelector + 'Input').attr('data-original-value');
                        $(ruleConditionsSelector).replaceWith(data);

                        var hasBackingDataInput = $(ruleConditionsSelector + 'Input').length > 0;
                        var valueControl = hasBackingDataInput ? $(ruleConditionsSelector + 'Input') : $(ruleConditionsSelector);

                        if (hadBackingDataInput === hasBackingDataInput)
                        {
                            valueControl.attr('data-original-value', originalValueAttr);
                        }

                        valueControl.trigger('change');

                        skyward.window.notifyDOMLoad(ruleConditionsSelector);
                    }
                }
            });
        };

        var handleTempThresholdRuleGroupChange = function ()
        {
            var thisEEL = $(this);
            var closestTableRow = thisEEL.closest('tr');
            var tableRowID = closestTableRow.first().attr('id');
            var trgCollapseRowID = tableRowID + '-ThresholdRuleGroupCollapsePanelRow';
            var trgCollapseRowSelector = '#' + trgCollapseRowID;

            var tempThresholdRuleGroupID = skyward.controls.getValue($(this));
            var htmlToAdd = 'See Threshold Rule Group Details for ID: ' + tempThresholdRuleGroupID;

            var getCollapsePanelHtml = function ()
            {
                return new Promise(function (resolve)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + "Student/TempThresholdRuleGroup/GetTempThresholdRuleGroupCollapsePanel",
                        type: "POST",
                        dataType: "viewparthtml",
                        data: {
                            districtID: $('#DistrictID').val(),
                            tempThresholdRuleGroupID: tempThresholdRuleGroupID,
                            tempThresholdRuleGroupTableName: $(thisEEL).data('tempTableName')
                        },
                        success: function (data)
                        {
                            resolve(data);
                        },
                        error: function ()
                        {
                            resolve(htmlToAdd); // fallback to default
                        }
                    });
                });
            };

            var shouldAjax = $('.js-tempThresholdRuleGroupID .codeEEL')
                .filter(function () { return skyward.controls.getValue($(this)) == tempThresholdRuleGroupID })
                .first().attr('id') == $(this).attr('id');

            if (shouldAjax)
            {
                getCollapsePanelHtml().then(function (resultHtml)
                {
                    htmlToAdd = resultHtml;
                    if (!closestTableRow.siblings(trgCollapseRowSelector)[0])
                    {
                        closestTableRow.after(`<tr id="${trgCollapseRowID}"><td colspan="4">${htmlToAdd}</td></tr>`);
                    } else
                    {
                        var relatedRow = closestTableRow.siblings(trgCollapseRowSelector).find('td')
                        // in future if we allow for changing Threshold Rule Group, we may want to preserve values in collapse panel if another ThresholdRule is using it.
                        relatedRow.html(htmlToAdd);
                        skyward.window.notifyDOMLoad(trgCollapseRowSelector);
                    }
                });
            } else
            {
                if (!closestTableRow.siblings(trgCollapseRowSelector)[0])
                {
                    closestTableRow.after(`<tr id="${trgCollapseRowID}"><td colspan="4">${htmlToAdd}</td></tr>`);
                } else
                {
                    var relatedRow = closestTableRow.siblings(trgCollapseRowSelector).find('td')
                    // in future if we allow for changing Threshold Rule Group, we may want to preserve values in collapse panel if another ThresholdRule is using it.
                    relatedRow.html(htmlToAdd);
                    skyward.window.notifyDOMLoad(trgCollapseRowSelector);
                }
            }
        }

        var handleRuleTypeChange = function (selector)
        {
            var ruleTypeInput = $(this);
            changeRuleType(ruleTypeInput, selector, false);
        };

        var changeRuleType = function (ruleTypeInput, selector)
        {
            var editThresholdRuleGroupSelector = '#editThresholdRuleGroup';
            var primaryKey;
            var tempThresholdRuleGroupID;
            var tempThresholdRuleGroupTableName;
            if (ruleTypeInput[0].id.startsWith('editThresholdRuleGroup') && $(editThresholdRuleGroupSelector).length > 0)
            {
                primaryKey = $(editThresholdRuleGroupSelector).data('primaryid');
            }
            else if (selector.endsWith('-ThresholdRuleGroupCollapsePanelRow'))
            {
                var tempEEL = $(selector.slice(0, -'-ThresholdRuleGroupCollapsePanelRow'.length)).find('.js-tempThresholdRuleGroupID .codeEEL')
                tempThresholdRuleGroupID = skyward.controls.getValue(tempEEL);
                tempThresholdRuleGroupTableName = tempEEL.data('tempTableName');
            }

            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/GetAllRuleConditionsForType",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    ruleTypeCode: ruleTypeInput.val(),
                    primaryKey: primaryKey,
                    tempThresholdRuleGroupID: tempThresholdRuleGroupID,
                    tempThresholdRuleGroupTableName: tempThresholdRuleGroupTableName,
                    entityID: $("input[name='EntityID']", selector).val() ?? $("input[name^='EntityID_TTRG']", selector).val(),
                    schoolYearID: $("input[name='SchoolYearID']", selector).val() ?? $("input[name^='SchoolYearID_TTRG']", selector).val(),
                    skipEntitySchoolYearFilter: $(".js-skipEntityYearConditionCheckbox", selector).prop("checked"),
                    otherEntityIDs: skyward.controls.getValue($(".js-otherEntityIDs", selector)),
                    otherSchoolYearIDs: skyward.controls.getValue($(".js-otherSchoolYearIDs", selector)),
                    otherEntityIDsControl: $(".js-otherEntityIDs", selector).attr("name"),
                    otherSchoolYearIDsControl: $(".js-otherSchoolYearIDs", selector).attr("name")
                },
                success: function (data)
                {
                    var ruleConditionsSelector = '#' + ruleTypeInput.parent().siblings('.ruleConditions')[0].id;
                    if ($(ruleConditionsSelector, selector)[0])
                    {
                        $(ruleConditionsSelector, selector).html(data);
                        skyward.window.notifyDOMLoad(ruleConditionsSelector);
                    }
                }
            });
        };                

        async function changeAssessmentTestField()
        {
            const testVersionFieldInput = $(this);
            const primaryKey = testVersionFieldInput.val();
            const id = testVersionFieldInput[0].id;
            let keyPrefix = '';
            if (id.startsWith('TempThresholdRuleGroup'))
            {
                keyPrefix = id.substring(0, id.indexOf('_') + 1);
            }
            const truncatedID = id.substring(keyPrefix.length);
            const idEnding = truncatedID.substring(truncatedID.indexOf("-"), truncatedID.lastIndexOf("_value"));
            const isDetails = id.includes('edit');
            const valueData = await $.ajax({
                url: `${skyward.global.virtualDir}Student/ThresholdRuleGroup/UpdateAssessmentValueViewPart`,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    testVersionFieldID: primaryKey,
                    keyPrefix: keyPrefix,
                    keyEnding: idEnding,
                    isDetails: isDetails,
                }
            });

            const valueContainer = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldValueOuterDiv');
            await valueContainer.viewpartHtml(valueData);
            skyward.window.notifyDOMLoad(valueContainer);

            const operationData = await $.ajax({
                url: `${skyward.global.virtualDir}Student/ThresholdRuleGroup/UpdateAssessmentOperation`,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    testVersionFieldID: primaryKey,
                    keyPrefix: keyPrefix,
                    keyEnding: idEnding,
                    isDetails: isDetails,
                }
            });

            const operationContainer = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldOperationOuterDiv');
            await operationContainer.viewpartHtml(operationData);
            skyward.window.notifyDOMLoad(operationContainer);
        }

        var handleTempThresholdRuleGroupNameChange = function ()
        {
            var nameField = $(this);

            var tempID = nameField.attr("id").slice((nameField.attr("id").indexOf('_')) + 1)

            if (tempID)
            {
                var eelInputs = $(`.js-tempThresholdRuleGroupID .codeEELValue[value=${tempID}]`);

                eelInputs.each(function ()
                {
                    $(this).first().parent().find('.codeEELCode').val(nameField.val())
                })
            }
        };

        var handleUseForMTSSChange = function ()
        {
            var useForMTSSCheckbox = $(this);

            if (useForMTSSCheckbox[0].checked)
            {
                $('.fsTier').show();
            }
            else
            {
                $('.fsTier').hide();
                $('.fsTier').find('.js-TierEEL').each(function ()
                {
                    skyward.controls.clearValue(this.parentElement);
                })
            }
        };

        /**
         * Used to handle visibility and clearing for dependents that are shared between multiple Use For options.
         * Otherwise, when unchecking an option individually, the framework dependent logic won't do what
         * we want because it will go to inverse a visible=true dependent when unchecking a checkbox even if another
         * checkbox in the group is checked and has the same visible=true dependent.
         */
        var processUseForDependents = function (selector, useForCheckboxGroup, isPageLoad)
        {
            var studentIndicatorFieldset = $(selector).find(".js-fsShowStudentIndicator");
            var studentIndicatorCheckbox = $(selector).find(".js-showStudentIndicator");
            var gradeLevelFieldset = $(selector).find(".js-fsGradeLevels");
            var gradeLevelDMSE = $(selector).find(".js-gradeLevels");

            var selectedOptions = {};
            useForCheckboxGroup.find(".checkbox").each(function ()
            {
                var checkboxName = $(this).attr("name");
                if (checkboxName.includes("selectAll"))
                {
                    return;
                }

                // Grab the last part of the dotted path (for workflows)
                var dotParts = checkboxName.split(".");
                if (dotParts.length > 1)
                {
                    checkboxName = dotParts[dotParts.length - 1];
                }

                selectedOptions[checkboxName] = skyward.controls.getValue($(this));
            });

            var useForAthleticEligibility = selectedOptions["UseForAthleticEligibility"];
            var useForAcademicEligibility = selectedOptions["UseForAcademicEligibility"];
            var useForMTSS = selectedOptions["UseForMTSS"];
            var useForScheduling = selectedOptions["UseForScheduling"];

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS || useForScheduling)
            {
                skyward.controls.show(studentIndicatorFieldset);
            }
            else
            {
                skyward.controls.hide(studentIndicatorFieldset);

                if (!isPageLoad)
                {
                    skyward.controls.clearValue(studentIndicatorCheckbox);
                }
            }

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS)
            {
                skyward.controls.show(gradeLevelFieldset);
            }
            else
            {
                skyward.controls.hide(gradeLevelFieldset);

                if (!isPageLoad)
                {
                    skyward.distinctMultiSelectEEL.values.clear(gradeLevelDMSE);
                }
            }
        };

        var processSkipEntitySchoolYearDependents = function (selector, skipEntitySchoolYearSelector, selectedRuleTypeCode, isInitialPageLoad)
        {
            var isEntitySpecific = true;
            var showSchoolSelector = true;

            // Check for all codes that filter by DistrictID instead of EntityID
            if (selectedRuleTypeCode == "GP") // GPA
            {
                isEntitySpecific = false;
            }
            if (selectedRuleTypeCode == "OF")
            {
                showSchoolSelector = false;
            }

            if (skipEntitySchoolYearSelector && isEntitySpecific)
            {
                skyward.controls.show($(".js-entitiesSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-entitiesSelect", selector));
            }

            if (skipEntitySchoolYearSelector && showSchoolSelector)
            {
                skyward.controls.show($(".js-schoolYearsSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-schoolYearsSelect", selector));
            }

            if (isInitialPageLoad)
            {
                return;
            }

            skyward.controls.clearValue($(".js-otherEntityIDs,.js-otherSchoolYearIDs", selector));
        };

        var handleReadonlyRuleTypes = function ()
        {
            var numberOfOccurences = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-numberOfOccurrences").find(".number");
            if (numberOfOccurences.length === 0)
            {
                return;
            }

            var operationTypeCode = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-operationTypeCode").find(".comboBoxSet");
            if (operationTypeCode.length === 0)
            {
                return;
            }

            var ruleTypesToForceReadonly = ["SD", "SP"];

            var additionalFieldsData = $(this).data("additionalFields");
            if (!additionalFieldsData || !additionalFieldsData["RuleTypeCode"] ||
                !ruleTypesToForceReadonly.includes(additionalFieldsData["RuleTypeCode"]))
            {
                skyward.controls.enable(numberOfOccurences);
                skyward.controls.enable(operationTypeCode);
                return;
            }

            skyward.controls.setValue(numberOfOccurences, 1);
            skyward.controls.disable(numberOfOccurences);
            skyward.controls.setValue(operationTypeCode, "GTOE");
            skyward.controls.disable(operationTypeCode);
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
